import React, { useContext, useEffect, useState } from "react";
import Header from "./Header";
import Navigation from "./Navigation";
import { AppState } from "../App";
import { useTimer } from "react-timer-hook";

const Teams = () => {
  const useAppState = useContext(AppState);
  const [data, setData] = useState([
    {
      sno: 0,
      id: 0,
      Address: "0",
      started: 0,
      Level: 0,
      Status: "",
      Direct: 0,
      referrer: 0
    },
  ]);
  const [layer, setLayer] = useState(1);

  useEffect(() => {
    async function getData() {
      let _team = await useAppState.staticContract.getMatrixUsers(
        useAppState.id, layer - 1
      );
      setData([]);
      for (let i = 0; i < _team.length; i++) {
        let isUserUnblocked = true;
        setData((prev) => [
          ...prev,
          {
            sno: i + 1,
            id: Number(_team[i].id),
            Address: _team[i].account,
            started: Number(_team[i].start),
            Level: Number(_team[i].level),
            Status: isUserUnblocked,
            Direct: Number(_team[i].directTeam),
            referrer: Number(_team[i].referrer)
          },
        ]);
      }
    }
    getData();
  }, [useAppState.walletAddress, useAppState.change, layer]);

  return (
    <>
    <img
        src="bgimg.png"
        className="fixed hidden md:block right-0 top-0 z-0 opacity-40"
      />
      <img
        src="bgmobimg.png"
        className="fixed w-full left-0 md:top-0 block md:hidden top-0 z-0 opacity-60"
      />
    
    <div className="pb-4 text-black dark:text-white transition-colors duration-1000 min-h-screen relative">
      <Header />
      <div className="flex justify-center w-full px-4 mt-6">
        <div className="w-full md:w-3/4">
          <Navigation />
        </div>
      </div>

      <div className="w-full flex justify-center p-4">
        <div className="mt-4 md:w-3/4 w-full">
            <div className='flex overflow-x-auto'>
              <p onClick={() => setLayer(1)} className={`cursor-pointer font-medium px-4 py-2 rounded-sm ${layer == 1 ? "bg-blue-500" : "bg-gray-700 bg-opacity-45"} ml-0`}>1</p>
              <p onClick={() => setLayer(2)} className={`cursor-pointer font-medium px-4 py-2 rounded-sm ${layer == 2 ? "bg-blue-500" : "bg-gray-700 bg-opacity-45"} ml-2`}>2</p>
              <p onClick={() => setLayer(3)} className={`cursor-pointer font-medium px-4 py-2 rounded-sm ${layer == 3 ? "bg-blue-500" : "bg-gray-700 bg-opacity-45"} ml-2`}>3</p>
              <p onClick={() => setLayer(4)} className={`cursor-pointer font-medium px-4 py-2 rounded-sm ${layer == 4 ? "bg-blue-500" : "bg-gray-700 bg-opacity-45"} ml-2`}>4</p>
              <p onClick={() => setLayer(5)} className={`cursor-pointer font-medium px-4 py-2 rounded-sm ${layer == 5 ? "bg-blue-500" : "bg-gray-700 bg-opacity-45"} ml-2`}>5</p>
              <p onClick={() => setLayer(6)} className={`cursor-pointer font-medium px-4 py-2 rounded-sm ${layer == 6 ? "bg-blue-500" : "bg-gray-700 bg-opacity-45"} ml-2`}>6</p>
              <p onClick={() => setLayer(7)} className={`cursor-pointer font-medium px-4 py-2 rounded-sm ${layer == 7 ? "bg-blue-500" : "bg-gray-700 bg-opacity-45"} ml-2`}>7</p>
              <p onClick={() => setLayer(8)} className={`cursor-pointer font-medium px-4 py-2 rounded-sm ${layer == 8 ? "bg-blue-500" : "bg-gray-700 bg-opacity-45"} ml-2`}>8</p>
              <p onClick={() => setLayer(9)} className={`cursor-pointer font-medium px-4 py-2 rounded-sm ${layer == 9 ? "bg-blue-500" : "bg-gray-700 bg-opacity-45"} ml-2`}>9</p>
              <p onClick={() => setLayer(10)} className={`cursor-pointer font-medium px-4 py-2 rounded-sm ${layer == 10 ? "bg-blue-500" : "bg-gray-700 bg-opacity-45"} ml-2`}>10</p>
              <p onClick={() => setLayer(11)} className={`cursor-pointer font-medium px-4 py-2 rounded-sm ${layer == 11 ? "bg-blue-500" : "bg-gray-700 bg-opacity-45"} ml-2`}>11</p>
              <p onClick={() => setLayer(12)} className={`cursor-pointer font-medium px-4 py-2 rounded-sm ${layer == 12 ? "bg-blue-500" : "bg-gray-700 bg-opacity-45"} ml-2`}>12</p>
            </div>

          <div class="overflow-x-scroll mt-4 w-full rounded-lg dark:text-white text-gray-800">
            <table class="w-full whitespace-nowrap">
              <thead class="bg-[#8080821a]">
                <th class="text-center font-bold py-3 px-2 border-2 text-lime-500 whitespace-nowrap border-[rgba(113,205,99,0.16)] bg-[rgba(128,203,112,0.14)]">SNo.</th>
                <th class="text-center font-bold py-3 px-2 border-2 text-lime-500 whitespace-nowrap border-[rgba(113,205,99,0.16)] bg-[rgba(128,203,112,0.14)]">ID</th>
                <th class="text-center font-bold py-3 px-2 border-2 text-lime-500 whitespace-nowrap border-[rgba(113,205,99,0.16)] bg-[rgba(128,203,112,0.14)]">Address</th>
                <th class="text-center font-bold py-3 px-2 border-2 text-lime-500 whitespace-nowrap border-[rgba(113,205,99,0.16)] bg-[rgba(128,203,112,0.14)]">Sponser ID</th>
                <th class="text-center font-bold py-3 px-2 border-2 text-lime-500 whitespace-nowrap border-[rgba(113,205,99,0.16)] bg-[rgba(128,203,112,0.14)]">Activation Date</th>
                <th class="text-center font-bold py-3 px-2 border-2 text-lime-500 whitespace-nowrap border-[rgba(113,205,99,0.16)] bg-[rgba(128,203,112,0.14)]">Level</th>
                <th class="text-center font-bold py-3 px-2 border-2 text-lime-500 whitespace-nowrap border-[rgba(113,205,99,0.16)] bg-[rgba(128,203,112,0.14)]">Direct Team</th>
              </thead>
              {data.map((e, i) => {
                return (
                  <tr key={i} class="">
                    <td class="text-center justify-center border-2 border-[rgba(89,124,240,0.16)] text-white bg-[rgba(89,117,240,0.14)] py-3 px-2">
                        {e.sno}
                    </td>

                    <td class="text-center py-3 px-2 border-2 border-[rgba(89,124,240,0.16)] text-white bg-[rgba(89,117,240,0.14)]">
                      {e.id}
                    </td>
                    <td class="text-center py-3 px-2 border-2 border-[rgba(89,124,240,0.16)] text-white bg-[rgba(89,117,240,0.14)]">
                      {e.Address.slice(0, 7)}...{e.Address.slice(37)}
                    </td>
                    <td class="text-center py-3 px-2 border-2 border-[rgba(89,124,240,0.16)] text-white bg-[rgba(89,117,240,0.14)]">
                      {e.referrer}
                    </td>
                    <td class="text-center py-3 px-2 border-2 border-[rgba(89,124,240,0.16)] text-white bg-[rgba(89,117,240,0.14)]">
                      {useAppState.getUTCTime(e.started * 1000)}
                    </td>
                    <td class="text-center py-3 px-2 border-2 border-[rgba(89,124,240,0.16)] text-white bg-[rgba(89,117,240,0.14)]">{useAppState.ranks[e.Level - 1]}</td>
                    <td class="text-center py-3 px-2 border-2 border-[rgba(89,124,240,0.16)] text-white bg-[rgba(89,117,240,0.14)]">{e.Direct}</td>
                  </tr>
                );
              })}
            </table>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default Teams;
